import { getCookie } from '@frontend/cookie';

const SITE_NAME_COOKIE = 'siteName';
const WEAVE_CHANNEL_COOKIE = 'weaveChannel';
const WEAVE_PARENT_DOMAIN = '.getweave.com';
const ALLOWED_CHANNELS = ['staging', 'edge'];

/**
 * Does not do IS_PROD check, but should only be run in production environments
 * Returns null for no-op
 */
export const getSiteNameFromCookie = (): string | null => {
  const channel = getCookie(WEAVE_CHANNEL_COOKIE);
  if (channel && ALLOWED_CHANNELS.includes(channel)) {
    return channel;
  }

  const siteNameAndDomain = getCookie(SITE_NAME_COOKIE);
  if (siteNameAndDomain) {
    const siteNameChannel = siteNameAndDomain.replace(WEAVE_PARENT_DOMAIN, '');
    if (siteNameChannel && ALLOWED_CHANNELS.includes(siteNameChannel)) {
      return siteNameChannel;
    }
  }

  return null;
};
